// CustomFirmwarePieChart.js
import React from "react";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";

// Colors for each firmware version slice
const COLORS = ["#4B6C87", "#C792EA", "#FFC966"];

const CustomFirmwarePieChart = ({ data }) => {
  return (
    <PieChart width={400} height={300}>
      <Pie
        data={data}
        cx="50%"
        cy="50%"
        outerRadius={80}
        dataKey="value"
        label={({ percent }) =>
          `${(percent * 100).toFixed(0)}%`
        }
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      {/* Optional: Show a tooltip on hover */}
      <Tooltip />
      {/* Legend appears below the chart */}
      <Legend verticalAlign="bottom" height={36} />
    </PieChart>
  );
};

export default CustomFirmwarePieChart;
